// @ts-nocheck
import { SVGContainer, Utils } from "@tldraw/core";
import {
  TLBaseShape,
  TLShapeUtilCanvasSvgDef,
  RecordProps,
  T,
  BoundsSnapGeometry,
  Rectangle2d,
  HTMLContainer,
  BaseBoxShapeUtil,
} from "tldraw";
import { GHOSTED_OPACITY } from "pages/flyer/builder/drawer/constants/constants";
import {
  defaultRectangleStyle,
  getBoundsRectangle,
  transformRectangle,
  transformSingleRectangle,
} from "pages/flyer/builder/drawer/state/shapes/shared";
import { styled } from "pages/flyer/builder/drawer/styles";
import { DashStyle, RectangleShape, ShapeStyles, TDMeta, TDShapeType } from "pages/flyer/builder/drawer/types";
import * as React from "react";
import { TDShapeUtil } from "../TDShapeUtil";
import { BindingIndicator } from "./components/BindingIndicator";
import { DashedRectangle } from "./components/DashedRectangle";
import { DrawRectangle } from "./components/DrawRectangle";
import { getRectangleIndicatorPathTDSnapshot } from "./rectangleHelpers";

type T = RectangleShape;
type E = HTMLDivElement;

export class RectangleUtil extends BaseBoxShapeUtil<T, E> {
  static type = TDShapeType.Rectangle as const;

  canBind = true;
  canClone = true;
  canEdit = true;

  getDefaultProps() {
    return {
      type: TDShapeType.Rectangle,
      x: 0,
      y: 0,
      rotation: 0,
      index: 1,
      isLocked: false,
      opacity: 1,
      parentId: "page",
      w: 0,
      h: 0,
      props: {
        id: "id",
        name: "Rectangle",
        childIndex: 1,
        point: [0, 0],
        size: [1, 1],
        style: defaultRectangleStyle,
        label: "",
        labelPoint: [0.5, 0.5],
      },
      meta: {},
    };
  }

  getBoundsSnapGeometry(shape: T): BoundsSnapGeometry {
    return new Rectangle2d({
      width: shape.props.w,
      height: shape.props.h,
      isFilled: true,
      x: 0,
      y: 0,
    });
  }

  component(shape: T) {
    const id = shape.id.replace(/^shape:/, "");
    const size = shape.props.size;
    const style = shape.props.style;

    const Component = style.dash === DashStyle.Draw ? DrawRectangle : DashedRectangle;

    return (
      <FullWrapper>
        <HTMLContainer
          style={{
            width: size[0],
            height: size[1],
            backgroundColor: style.fillColor,
            border: style.isStroked ? `${style.strokeWidth}px solid ${style.strokeColor}` : "none",
            borderRadius: style.rounded,
            opacity: 1,
          }}
          id={id}
        >
          {/* <DrawRectangle id={id} style={style} size={size} isSelected={false} isDarkMode={false} /> */}
          <Component id={id} style={style} size={size} isSelected={false} isDarkMode={false} />
        </HTMLContainer>
      </FullWrapper>
    );
  }
  // Component = TDShapeUtil.Component<T, E, TDMeta>(
  //   (
  //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //     { shape, isBinding, isSelected, isGhost, meta, events, onShapeChange },
  //     ref
  //   ) => {
  //     const { id, size, style } = shape;
  //     const Component = style.dash === DashStyle.Draw ? DrawRectangle : DashedRectangle;

  //     return (
  //       <FullWrapper ref={ref} {...events}>
  //         <SVGContainer id={shape.id + "_svg"} opacity={isGhost ? GHOSTED_OPACITY : 1}>
  //           {isBinding && <BindingIndicator strokeWidth={0} size={size} />}
  //           <Component id={id} style={style} size={size} isSelected={isSelected} isDarkMode={meta.isDarkMode} />
  //         </SVGContainer>
  //       </FullWrapper>
  //     );
  //   }
  // );
  // indicator(shape: T) {
  //   const id = shape.id.replace(/^shape:/, "");
  //   const size = shape.props.size;
  //   const style = shape.props.style;

  //   if (style.dash === DashStyle.Draw) {
  //     return <path d={getRectangleIndicatorPathTDSnapshot(id, style, size)} />;
  //   }

  //   return <rect width={Math.max(1, size[0])} height={Math.max(1, size[1])} />;
  // }

  // getBounds = (shape: T) => {
  //   return getBoundsRectangle(shape, this.boundsCache);
  // };

  // shouldRender = (prev: T, next: T) => {
  //   return next.size !== prev.size || next.style !== prev.style || next.label !== prev.label;
  // };

  // transform = transformRectangle;
  // transformSingle = transformSingleRectangle;
}

const FullWrapper = styled("div", { width: "100%", height: "100%" });

type IPlayingCard = TLBaseShape<
  "PlayingCard",
  {
    w: number;
    h: number;
    suit: string;
    fill: string;
  }
>;

export class PlayingCardUtil extends BaseBoxShapeUtil<IPlayingCard> {
  static override type = "PlayingCard" as const;
  static override props: RecordProps<IPlayingCard> = {
    w: T.number,
    h: T.number,
    suit: T.string,
    fill: T.string,
  };

  override isAspectRatioLocked(_shape: IPlayingCard) {
    return true;
  }

  getDefaultProps(): IPlayingCard["props"] {
    const cardSuitsArray: string[] = ["♠️", "♣️", "♥️", "♦️"];
    const randomSuit = cardSuitsArray[Math.floor(Math.random() * cardSuitsArray.length)];
    return {
      w: 270,
      h: 370,
      suit: randomSuit,
      fill: "red",
    };
  }

  override getBoundsSnapGeometry(shape: IPlayingCard): BoundsSnapGeometry {
    return new Rectangle2d({
      width: shape.props.h / 4.5,
      height: shape.props.h / 4.5,
      isFilled: true,
      x: 0,
      y: 0,
    });
  }

  // [7]
  component(shape: IPlayingCard) {
    return (
      <HTMLContainer
        style={{
          height: shape.props.h,
          width: shape.props.w,
          backgroundColor: shape.props.fill,
          boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 8,
          borderRadius: "10px",
        }}
        id={shape.id}
      >
        <span
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: shape.props.h / 4.5,
            width: shape.props.h / 4.5,
            fontSize: shape.props.h / 5,
          }}
        >
          {shape.props.suit}
        </span>
        <div style={{ fontSize: shape.props.h / 3 }}>{shape.props.suit}</div>
      </HTMLContainer>
    );
  }

  // [7]
  indicator(shape: IPlayingCard) {
    return this.component(shape);
  }
}
